/**
 * BudgetOS-only demo storefront link (“Get the full version” on the demo bar).
 *
 * Each product app under `apps/` must keep its OWN `src/demoConfig.ts` —
 * do not share this URL with other demos (TherapyDash, PawBook, etc.).
 *
 * Paste the BudgetOS Etsy listing URL below.
 */
export const DEMO_ETSY_URL = "https://www.etsy.com/shop/VaultOSHQ";
